import Swiper from 'swiper';
import { FreeMode } from 'swiper/modules';

function initSwiper(element) {
  const swiper = new Swiper(element, {
    modules: [FreeMode],
    freeMode: true,
    spaceBetween: 0,
    slidesPerView: 'auto',
    watchSlidesProgress: true,
    init: false,
  });

  swiper.on('progress', (swiper, progress) => {
    if (progress <= 0) {
      element.classList.add('swiper--is-at-beginning');
    } else {
      element.classList.remove('swiper--is-at-beginning');
    }

    if (progress >= 1) {
      element.classList.add('swiper--is-at-end');
    } else {
      element.classList.remove('swiper--is-at-end');
    }
  });

  const doesNeedEdges = () => {
    let needsEdges = false;
    swiper.slides.forEach((slide) => {
      if (!slide.classList.contains('swiper-slide-fully-visible')) {
        needsEdges = true;
      }
    });
    if (needsEdges) {
      element.classList.add('swiper--has-fading-edges');
    } else {
      element.classList.remove('swiper--has-fading-edges');
    }
  };

  swiper.on('afterInit', () => {
    window.addEventListener('resize', () => needsEdges());
    doesNeedEdges();
  });

  swiper.init();

  return swiper;
}

function init(parent) {
  const swiperElement = parent.querySelector('.categories-slider__swiper');
  const swiper = initSwiper(swiperElement);

  const links = [...parent.querySelectorAll('.categories-slider__link')];

  const select = (newLink) => {
    console.log(newLink);
    links.forEach((link) => {
      if (link === newLink) {
        link.classList.add('is-active');
      } else {
        link.classList.remove('is-active');
      }
    });

    const idx = links.indexOf(newLink);
    if (idx !== -1) {
      swiper.slideTo(idx);
    }
  };

  links.forEach((link) => {
    link.addEventListener('click', () => select(link));
  });
}

export function categoriesSlider(selector = '.categories-slider') {
  document.querySelectorAll(selector).forEach((element) => init(element));
}
